import { useRef, useState } from 'react';
import { Button, Heading, Popup, PopupSection } from '@flixbus/honeycomb-react';
import { Icon, IconDot } from '@flixbus/honeycomb-icons-react';

import { useBatchUpdate } from '../../context/VoucherBatchUpdateProvider';
import { useNotification } from '../Notifications/Context';
import { useVoucherList } from '../../context/VoucherListProvider';

import { fetchVoucherBatch } from '../../apis';
import { BatchUpdatePayload } from '../../types/BatchUpdate';

const EnableButton = () => {
  const [popupActive, setPopupActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const { pushToast } = useNotification();
  const { payload, clearSelection } = useBatchUpdate();
  const { refetch } = useVoucherList();
  const targetRef = useRef(null);

  const vouchersCount = payload.batches[0].ids.length;

  const onClick = async () => {
    setLoading(true);

    const query: BatchUpdatePayload = {
      ...payload,
      batches: payload.batches.map(batch => ({
        ...batch,
        query: {
          ...batch.query,
          status: 'active',
        },
      })),
    };

    await fetchVoucherBatch(query);

    setLoading(false);
    setPopupActive(false);

    pushToast({
      message: `${vouchersCount} voucher(s) were successfully enabled`,
      status: 'success',
    });

    setTimeout(() => {
      refetch();
      clearSelection();
    }, 1000);
  };

  return (
    <>
      <Button
        appearance='link'
        onClick={() => setPopupActive(p => !p)}
        disabled={vouchersCount === 0}
      >
        <Icon InlineIcon={IconDot} />
        Enable
      </Button>
      <Popup
        active={popupActive}
        onOverlayClick={() => setPopupActive(false)}
        targetRef={targetRef}
      >
        <PopupSection type='icon'>
          <Icon InlineIcon={IconDot} size={12} style={{ fill: 'var(--hcr-neutral-color)' }} />
        </PopupSection>
        <PopupSection type='title'>
          <Heading size={2} sectionHeader flushSpace>
            Enable voucher(s)?
          </Heading>
        </PopupSection>
        <PopupSection type='content'>
          You are about to enable <strong>{vouchersCount}</strong> vouchers. Make sure you selected
          the correct vouchers before continuing.
        </PopupSection>
        <PopupSection type='actions'>
          <Button onClick={() => setPopupActive(false)}>Go Back</Button>
          <Button appearance='primary' onClick={onClick} loading={loading}>
            Confirm
          </Button>
        </PopupSection>
      </Popup>
    </>
  );
};

export default EnableButton;
